<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="测点组名称" prop="groupName">
              <a-input placeholder="请输入测点组名称" v-model="model.groupName"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="测点详情">
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item @click="batchDel" key="1"> <a-icon type="delete" />删除 </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px">
              批量操作
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
            >项
            <a @click="onClearSelected" style="margin-left: 24px">清空</a>
          </div>
          <a-table
            :columns="columns"
            :customRow="customRowRender"
            :dataSource="dataSource"
            :loading="loading"
            :pagination="false"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :scroll="{ x: true }"
            @change="handleTableChange"
            bordered
            class="j-table-force-nowrap"
            ref="table"
            rowKey="id"
            size="middle"
          >
            <template slot="htmlSlot" slot-scope="text">
              <div v-html="text"></div>
            </template>
            <template slot="imgSlot" slot-scope="text">
              <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
              <img
                :src="getImgView(text)"
                alt
                height="25px"
                style="max-width:80px;font-size: 12px;font-style: italic;"
                v-else
              />
            </template>
            <template slot="fileSlot" slot-scope="text">
              <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
              <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else
                >下载</a-button
              >
            </template>
          </a-table>
        </div>
        <!-- <iot-model-points-group-menber-modal ref="modalForm" @ok="modalFormOk"></iot-model-points-group-menber-modal> -->
        <iot-model-points-modal-detail @ok="modalFormOk" ref="modalFormDetail" />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { getAction, httpAction } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { DragTableModelMixin } from '@/mixins/DragTableModelMixin'
/* import IotModelPointsGroupMenberModal from './IotModelPointsGroupMenberModal' */
import IotModelPointsModalDetail from './IotModelPointsModalForDetail'

export default {
  name: 'IotModelPointsGroupForm',
  mixins: [DragTableModelMixin, JeecgListMixin, mixinDevice],
  components: {
    /* IotModelPointsGroupMenberModal, */
    IotModelPointsModalDetail
  },
  data() {
    return {
      disableMixinCreated: true,
      form: this.$form.createForm(this),
      confirmLoading: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      labelCol3: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol3: {
        xs: { span: 15 },
        sm: { span: 15 }
      },
      model: {
        id: '',
        groupName: '',
        iotModelPointsGroupMenberList: []
      },
      validatorRules: {
        groupName: [{ required: true, message: '请输入测点组名称!' }]
      },
      refKeys: ['iotModelPointsGroupMenber'],
      activeKey: 'iotModelPointsGroupMenber',
      isorter: {
        column: 'orderNo',
        order: 'asc'
      },
      url: {
        add: '/monitor/iotModelPointsGroup/add',
        edit: '/monitor/iotModelPointsGroup/edit',
        queryById: '/monitor/iotModelPointsGroup/queryById',
        iotModelPointsGroupMenber: {
          list: '/monitor/iotModelPointsGroup/queryIotModelPointsGroupMenberByMainId'
        },
        list: '/monitor/iotModelPointsGroupMenber/list',
        delete: '/monitor/iotModelPointsGroupMenber/delete',
        deleteBatch: '/monitor/iotModelPointsGroupMenber/deleteBatch',
        sort: '/monitor/iotModelPointsGroupMenber/editSort'
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '测点编码',
          align: 'center',
          dataIndex: 'pointCode'
        },
        {
          title: '测点名称',
          align: 'center',
          dataIndex: 'pointName'
        }
        /*  {
               title: '测点组',
               align: "center",
               dataIndex: 'groupId_dictText'
           },  
          {
              title: '操作',
              dataIndex: 'action',
              align: "center",
              fixed: "right",
              width: 147,
              scopedSlots: { customRender: 'action' }
          } */
      ],
      listPagination: {
        pageSize: 50,
        pageSizeOptions: ['50', '100', '200', '300']
      }
    }
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  created() {},
  methods: {
    add(checkedPointList) {
      this.edit(this.model)
      this.dataSource = [...checkedPointList]
    },
    edit(record) {
      this.url.list = '/monitor/iotModelPointsGroupMenber/list?groupId=' + record.id
      if (typeof this.editBefore === 'function') this.editBefore(record)
      this.activeKey = this.refKeys[0]
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.dataSource = this.model.iotModelPointsGroupMenberList
      if (typeof this.editAfter === 'function') this.editAfter(this.model)
    },
    copy(record) {
      this.url.list = '/monitor/iotModelPointsGroupMenber/list?groupId=' + record.id
      if (typeof this.editBefore === 'function') this.editBefore(record)
      this.activeKey = this.refKeys[0]
      this.form.resetFields()
      //复制 把主键id、点组名称去掉
      record.id = ''
      record.groupName = ''
      this.model = Object.assign({}, record)
      this.dataSource = this.model.iotModelPointsGroupMenberList
      if (typeof this.editAfter === 'function') this.editAfter(this.model)
    },
    close() {
      this.$emit('close')
    },
    handleOk() {
      const that = this
      //默认给上序号
      this.model.iotModelPointsGroupMenberList = this.dataSource.map((item, index) => {
        Object.assign(item, {
          orderNo: index + 1
        })
        delete item.id
        return item
      })
      // 触发表单验证
      this.validateFields(['groupName'], err => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!that.model.id) {
            httpurl += that.url.add
            method = 'post'
          } else {
            httpurl += that.url.edit
            method = 'put'
          }
          let formData = Object.assign(that.model)
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.$emit('ok')
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    /**
     * 验证字段
     * @param arr
     * @param callback
     */
    validateFields(arr, callback) {
      let promiseArray = []
      for (let item of arr) {
        let p = new Promise((resolve, reject) => {
          this.$refs['form'].validateField(item, err => {
            if (!err) {
              resolve()
            } else {
              reject(err)
            }
          })
        })
        promiseArray.push(p)
      }
      Promise.all(promiseArray)
        .then(() => {
          callback()
        })
        .catch(err => {
          callback(err)
        })
    },
    modalFormOk(data) {
      if (!this.dataSource || this.dataSource.length == 0) {
        this.dataSource = data
      } else {
        //合并去重
        const arrayObject = this.dataSource.concat(data)
        let obj1
        let obj2
        for (obj1 of arrayObject) {
          let flag = true
          for (obj2 of this.dataSource) {
            if (obj1.pointCode === obj2.pointCode && obj1.pointName === obj2.pointName) {
              flag = false
            }
          }
          if (flag) {
            this.dataSource.push(obj1)
          }
        }
      }
      this.model.iotModelPointsGroupMenberList = this.dataSource
      // 新增/修改 成功时，重载列表
      // 清空列表选中
      this.onClearSelected()
    },
    handleAdd: function() {
      this.$refs.modalFormDetail.add()
      this.$refs.modalFormDetail.title = '新增'
      this.$refs.modalFormDetail.disableSubmit = false
    }
  }
}
</script>

<style scoped>

</style>
